import { render, staticRenderFns } from "./MonthFilter.vue?vue&type=template&id=5834154a&scoped=true&"
import script from "./MonthFilter.vue?vue&type=script&lang=js&"
export * from "./MonthFilter.vue?vue&type=script&lang=js&"
import style0 from "./MonthFilter.vue?vue&type=style&index=0&id=5834154a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5834154a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
